import artikelauswahlClient from "@/legacy/artikelauswahlClient";
import { webCookie } from "@/lib/cookies";
import { getAuthenticationTicket } from "@/lib/formsAuthentication";
import { WarenkorbTyp } from "@/lib/models/warenkorb";
import { apiEndpoints, environment } from "@/lib/resources";
import { updateWarenkorbOverlay } from "@/lib/warenkorb";
import $ from "jquery";

// Dieser Code kümmert sich um Modals für PDF-Normen und KIM-Konfigurator bei ReLounge
// Bei Inocon übernimmt das Avenit

const normblattModal = $("[data-normblatt-modal]");

// Muss geprüft werden da Fancybox trotzem intern in einen Fehler läuft aber diesen nicht throwed
// Zum Anschauen das error event hinzufügen und drauf abhören
if (normblattModal.length && !environment.inocon) {
	normblattModal.fancybox({
		// @ts-ignore Typedefs kennen die Prop nicht, macht aber auch nix kaputt
		scrollOutside: "false",
		closeClick: false,

		autoFocus: false,
		keyboard: true,
		touch: false,
		toolbar: false,
		smallBtn: true,
		btnTpl: {
			smallBtn: `<button id="fancybox-data-closebutton" data-fancybox-close class="button--close-light"></button>`,
		},
		afterShow: (instance, current) => {
			$("#fancybox-data-closebutton").prop("title", instance.$trigger!.data("closetext"));

			// <GKS-4532@29829> Erst beim Öffnen des Modals wird data-src in src kopiert und die URL geladen.
			// Siehe Kommentar im View zu data-normblatt-modal.
			current.$content!
				.find("iframe[data-src]")
				.each((_, el) => void ($(el).prop("src", $(el).data("src"))));
		},
		afterClose: () => updateWarenkorbOverlay(),
	});
}

if (environment.inocon) {
	document.body.addEventListener("afterClose.fb.av", () => {
		// Die Positionen müssen nur aktualisiert werden, wenn es sich um einen Fancybox einer Kim-Norm handelt.
		// Da das Event von Avenit bei jeder Fancybox gefeuert wird, wird hier auf das vorhanden Sein einer Kim Norm geprüft.
		if ($("[data-kim-norm]")[0] == null) return;

		$.ajax({
			type: "GET",
			url: apiEndpoints.warenkorbOverlay,
			cache: false,
			data: {
				profileId: webCookie.id,
				warenkorbTyp: WarenkorbTyp.Warenkorb,
				authenticationTicket: getAuthenticationTicket(),
				identityCulture: environment.identityCulture,
			},
			success: (data) => {
				artikelauswahlClient.AktualisiereMengenAnzeige(WarenkorbTyp.Warenkorb, data.AnzahlPositionen);
			},
		});
	});
}
